import React from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import './Doc.scss';
import './Doc-media.scss';
import {IWordpressFile} from "../../services/content/interfaces/IWordpressFile";
import {GetIconDoc} from "../Doc/functions";
import {IconDownload} from "../Doc/icons";

const getTypeByMimeType = (mimeType: string) => {
  switch (mimeType) {
    case 'application/vnd.ms-excel':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'excel';
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'word';
    case 'application/pdf':
      return 'pdf';
    default:
      return 'pdf';
  }
}

const WordpressDoc = ({ title, name, mime_type, filesize, date, type, url }: IWordpressFile) => {
  return (
    <a className="doc" href={url} download>
      {GetIconDoc(getTypeByMimeType(mime_type))}
      <div className="doc__info">
        <p className="body2 doc__name">{title}</p>
        <p className="doc__size">{`${Math.ceil(filesize / 1024)} кб`}</p>
        <span className="doc__point"></span>
        <p className="doc__date">{date}</p>
      </div>
      {IconDownload}
    </a>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(WordpressDoc));
